import { render, staticRenderFns } from "./CardCircle.vue?vue&type=template&id=2cf55a61&scoped=true&"
import script from "./CardCircle.vue?vue&type=script&lang=js&"
export * from "./CardCircle.vue?vue&type=script&lang=js&"
import style0 from "./CardCircle.vue?vue&type=style&index=0&id=2cf55a61&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf55a61",
  null
  
)

export default component.exports